import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import cookies from 'js-cookie'
import qs from 'qs'

import './assets/css/global.css'
import './assets/css/font-awesome-4.7.0/css/font-awesome.min.css'

Vue.config.productionTip = false

Vue.use(qs)
Vue.use(cookies)

Vue.prototype.$qs = qs
Vue.prototype.$cookies = cookies

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
